import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Container from '../../../../components/Container';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../view-home.css';
import SearchInput from '../../../Search/components/SearchInput';
import '../../view-home.css'; 
import { Alert } from '@mui/material';

/*
const OcpfPhotos = [
  {
    title: "OCPF1",
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic1.png',
  },
  {
    title: 'OCPF2',
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic2.png',
  },
  {
    title: 'OCPF3',
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic3.png?t=vuYrFKBa',
  },
  {
    title: 'OCPF4',
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic4.png',
  }
];
*/

const OcpfPhotos = [
    {
      pictureId: 1,
      pictureName: "homepage_slider_pic1.png"
    }
];

interface Photo {
  pictureId: number;
  pictureName: string;
}


const Hero = (): JSX.Element => {

  const [ocpfPhotos, setOcpfPhotos] = React.useState<Photo[]>();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  //custom breakpoint;
  const isXXL = useMediaQuery('(min-width:1537px)');

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  useEffect(() => {
    getHomepagePictures();
  }, []);

  const getHomepagePictures = async () => {

    try{
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/photos`);
      if (!response.ok) {
        //if API response is not ok, set default photos
        setOcpfPhotos(OcpfPhotos);
        //throw new Error(`Failed to fetch homepage pictures (${response.status})`);

      }
      const data = await response.json();
      setOcpfPhotos(data);
    }
    catch(error) {
      console.error('Uncaught Error:', error);
      //if error, set default photos
      setOcpfPhotos(OcpfPhotos);
    }
  }
  
  
  const LeftSide = () => (
    <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
      <Box marginBottom={2}>
        <Typography
          color={'primary.ocpfBlue'}
          component={'span'}
          variant="h4"
          fontWeight={550}
        >
          Welcome to the Massachusetts Office of Campaign and Political Finance
        </Typography>
      </Box>
      <Box marginBottom={3}>
        <Typography variant="h6" component="p" color="text.secondary">
        OCPF is an independent agency charged with overseeing compliance with the campaign finance law.
        </Typography>
      </Box>
      <Box display="flex" flexDirection={'column'} justifyContent={'center'}>
        <Box marginBottom={2}></Box>
        <Box
          padding={1}
          width={1}
          component={Card}
          boxShadow={4}
          marginBottom={0}
          sx={{
            '& .MuiInputBase-input.MuiOutlinedInput-input': {
              bgcolor: 'background.paper',
              padding: '0 !important',
            },
          }}
        >  
        <Box display="flex" alignItems={'center'}>
            <Box width={1} marginRight={1}>
              <SearchInput></SearchInput>
            </Box>
        </Box>
      </Box>
      </Box>
    </Box>
  );

  const RightSide = (item: Photo): JSX.Element => {
    return (
      <Box
        sx={{
          height: { xs: 'auto', md: 1 },
          overflow: 'hidden',
          '& img': {
            objectFit: 'cover',
          },
        }}
      >
        <Box
          role='presentation'
          component={'img'}
          loading="lazy"
          src={`https://ocpf2.blob.core.windows.net/website-content/homepage-slider/${item.pictureName}`}
          height={{ xs: 'auto', md: 1 }}
          maxHeight={{ xs: 200, md: 1 }}
          width={1}
          maxWidth={1}
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        bgcolor: 'alternate.main',
        width: 1,
        height: 1,
        marginTop:2,
        overflow: 'hidden',
      }}
      className="homepage-hero"
    >
      <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'column', lg: 'row' }}
          position={'relative'}
        >
          <Box width={1} order={{ xs: 2, md: 1 }}>
            <Container>
              <LeftSide />
            </Container>
          </Box>
          <Box
            sx={{
              flex: { xs: '0 0 100%', md: '0 0 50%' },
              position: 'relative',
              maxWidth: { xs: '100%', md: '50%' },
              order: { xs: 1, md: 2 },
            }}
          >
            <Box
              sx={{
                width: { xs: 1, md: '50vw' },
                height: '100%',
                position: 'relative',
              }}
            >
              <Box
                  sx={{
                    overflow: isXXL ? 'hidden' : 'visible',
                    left: '0%',
                    width: 1,
                    height: 1,
                    position: { xs: 'relative', md: 'absolute' },
                    clipPath: {
                      xs: 'none',
                      md: 'polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%)',
                    },
                    shapeOutside: {
                      xs: 'none',
                      md: 'polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%)',
                    },
                  }}
                >
                  <Slider {...sliderSettings}>
                    {ocpfPhotos && ocpfPhotos.length>0 && ocpfPhotos.map((item: Photo, index) => (
                      <Box key={index} height={1} width={1} >
                        {RightSide(item)}
                      </Box>
                    ))}
                  </Slider>
                </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      <Divider />
    </Box>
  );
};

export default Hero;
